import axios from "axios";
import { FETCH } from "@/store/action-types";
import { TOGGLE_LOADING, ERROR } from "@/store/mutation-types";

import { Perimetre } from "@/models/Perimetre";

// The API util is used to send the
// data the company enters to our server.
import {
  RepositoryFactory,
  PERIMETRES_REPOSITORY
} from "@/utils/RepositoryFactory";
const PerimetreRepository = RepositoryFactory.get(PERIMETRES_REPOSITORY);

const getDefaultState = () => ({
  loading: false
});

const state = getDefaultState();

const getters = {};

let call;

const actions = {
  async [FETCH]({ commit }, { searchQuery, perimetreTypeId, applicationId }) {
    if (call) {
      call.cancel("Only one request allowed at a time.");
    }

    call = axios.CancelToken.source();

    commit(TOGGLE_LOADING, true);

    try {
      const res = await PerimetreRepository.get({
        searchQuery,
        perimetreTypeId,
        applicationId,
        cancelToken: call.token
      });

      const { data } = res;

      commit(TOGGLE_LOADING, false);

      return data.content.list.map(entity => new Perimetre(entity));
    } catch (error) {
      if (!axios.isCancel(error)) {
        commit(
          `app/${ERROR}`,
          { error, message: error.message },
          { root: true }
        );
        commit(TOGGLE_LOADING, false);
      } else {
        commit(TOGGLE_LOADING, true);
      }
    }
  }
};

const mutations = {
  [TOGGLE_LOADING](state, toggle) {
    if (toggle == null) {
      toggle = !state.loading;
    }
    // eslint-disable-next-line no-param-reassign
    state.loading = toggle;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
